import { Image, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ICardProps {
  imgSrc: string;
  title: string;
  text: string;
}

export const Card = React.forwardRef<HTMLDivElement, ICardProps>(({ imgSrc, text, title }, ref) => {
  return (
    <div ref={ref}>
      <Image src={imgSrc} alt="" width="100%" />
      <div className={styles['title']}>
        <UIHeading1>{title}</UIHeading1>
      </div>
      <UIText1>{text}</UIText1>
    </div>
  );
});

Card.displayName = 'Card';
